__webpack_require__.p = "/catalogo-barbantes/";